import { classifications } from '@mep/pae-commons';
import { Empty, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const { SKIN_COLOR_ENUM } = classifications;

const { Option } = Select;

const SkinColorSelect = ({ value, onChange, ...props }) => {
  const { t } = useTranslation('common');
  
  const onClearHandler = useCallback(() => {
    onChange && onChange(null);
  }, [onChange]);
  
  return (
    <Select
      showSearch={false}
      allowClear={false}
      {...props}
      notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
      value={value}
      onChange={onChange}
      onClear={onClearHandler}
    >
      {SKIN_COLOR_ENUM
        .map((element, index) => {
          return <Option key={index} value={element} title={t(`skinColors.${element}`)}>
            <Tooltip title={t(`skinColors.${element}`)}>{t(`skinColors.${element}`)}</Tooltip>
          </Option>;
        })}
    </Select>
  );
};

SkinColorSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default memo(SkinColorSelect);
